export enum TrophyRarity {
  UltraRare,
  VeryRare,
  Rare,
  Common
}
